


import React, { useLayoutEffect, useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonToolTip, CstmPagination } from "../../../../components/Common/Common";
import { generatePath, Link, useNavigate } from "react-router-dom";
import {
    useDeleteTherapistMutation,
    useGetTherapistsListQuery,
    useResendAccountActivationMutation
} from "store/services/therapistProfiles";
import { APPOINTMENT_ADD, APPOINTMENT_DETAILS, APPOINTMENT_EDIT, THERAPIST_DETAIL, THERAPIST_EDIT } from "config/paths";
import LoadingOverlay from "components/shared/LoadingOverlay";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { ArchiveIcon, ChatIcon, DeleteIcon, EditIcon, UnArchiveIcon } from "Assets/icons";
import { successMessageToast, userFullName } from "helpers/common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ErrorComponent from "components/shared/ErrorComponent";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import dummyUserImage from "Assets/images/dummy_user.jpg";
import AlertPop from "components/Modals/AlertPop";
import { useArchiveTherapistMutation } from "store/services/archive";
import { useDispatch, useSelector } from "react-redux";
import { appointmentsFilter, consentFormFilter, therapistProfilesFilter } from "store/slices/filter";
import { APPOINTMENT_PAYMENT_OPTIONS, APPOINTMENT_SESSION_TYPE_OPTIONS, THERAPIST_TYPE_OPTIONS } from "config/constants";
import { useDeleteAppointmentMutation, useGetAppointmentListQuery } from "store/services/appointment";

const ViewAppointment = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const filter = useSelector(state => state?.filter?.appointmentsFilter);

    const [modalType, setModalType] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    // const [therapistProfiles, setTherapistProfiles] = useState([]);
    const { data: appointmentList, isFetching: appointmentLoading, isError } = useGetAppointmentListQuery({ page: currentPage, limit: pageSize, ...filter })
    const [deleteAppointment, { isLoading: deleteAppointmentLoading }] = useDeleteAppointmentMutation();


    // const { data, isLoading, isFetching, refetch } = useGetTherapistsListQuery({
    //     page: currentPage,
    //     limit: pageSize,
    //     ...filter,
    // });

    const [resendAccountActivation, { isLoading: resendAccountActivationLoading }] = useResendAccountActivationMutation();


    const totalRecords = appointmentList?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const handleEditItem = (id) => {
        navigate(generatePath(APPOINTMENT_EDIT, { id }));
    };


    const column = useMemo(() => [
        {
            head: "Title",
            accessor: "title",
            // sorter: true,
            component: (item) => (
                <div className="d-flex align-items-center gap-10">
                    <h6 className="m-0 fw-sbold">
                        <Link
                            className="text-dark"
                            to={generatePath(THERAPIST_DETAIL, { id: item.id })}
                        >
                            {item.title || "--"}
                        </Link>
                    </h6>
                </div>)
        },
        {
            head: <div className="w-100 d-flex justify-content-center">Client</div>,
            accessor: "client_id",
            // sorter: true,
            component: (item, index) => (
                <p className="text_cap text-center">{userFullName(item?.appointmentClient) || "--"}</p>
            )
        },
        {
            head: <div className="w-100 d-flex justify-content-center">Parent</div>,
            accessor: "guardian_id",
            component: (item, index) => (
                <p className="text_cap text-center">{userFullName(item?.appointmentGuardian) }</p>
            )
        },
        {
            head: <div className="w-100 d-flex justify-content-center">Appointment</div>,
            accessor: "appointment_type",
            isComponent: true,
            component: (item, index) => (
                <p className="text_cap text-center">{item?.appointment_type}</p>
            )
        },
        {
            head: "Payment Status",
            accessor: "payment_status",
            // sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 80 }}
                    className={`${item?.appointment_type == "funded"  ? "redStatus" : item.payment_status == "success"
                        ? "greenStatus"
                        : item.payment_status == "pending" ? "yellowStatus" : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {item?.appointment_type == "funded" ? "N/A" : item.payment_status}
                </p>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item, x) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    <CommonToolTip
                        text={"Edit"}
                        component={<Button
                            disabled={item.payment_status == "success"}
                            onClick={(e) => {
                                e.stopPropagation()
                                handleEditItem(item.id)
                            }}
                            className="p-0"
                            variant="transparent"
                            type="button"
                        >
                            <EditIcon />
                        </Button>}
                    />
                    {/* <CommonToolTip
                        text={item?.status == "active" ? "Archive" : "Unarchive"}
                        component={<Button
                            onClick={(e) => {
                                e.stopPropagation();
                                setModalType(item?.status == "active" ? "archive" : "active");
                                setCurrentEntry(item);
                                setShowModal(true);
                            }}
                            className="p-0"
                            variant="transparent"
                            type="button"
                        >
                            {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
                        </Button>}
                    /> */}
                    {/* <CommonToolTip
                        text={"Resend Mail"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation()

                                if (item?.email_verified_at) {

                                    setShowAlertModal(true);
                                    return;
                                };
                                setModalType("resendAccountActivationMail")
                                setCurrentEntry(item);
                                setShowModal(true);
                            }}
                        >
                            <ChatIcon />
                        </Button>}
                    /> */}
                    <CommonToolTip
                        text={"Delete"}
                        component={<Button
                        disabled={item.payment_status == "success"}
                            onClick={(e) => {
                                e.stopPropagation()
                                setModalType("delete")
                                setCurrentEntry(item);
                                setShowModal(true);
                            }}
                            className="p-0"
                            variant="transparent"
                            type="button"
                        >
                            <DeleteIcon />
                        </Button>}
                    />
                </div>
            ),
        },
    ]);

    const resetFilter = () => {
        dispatch(appointmentsFilter({ search: "", type: "", status: "active", sort: { column: "id", direction: "desc", } }));
        setCurrentPage(1)
    };

    const handleFilterChange = (key) => (value) => {
        console.log("HANDLE FILTER  ", key, value)
        dispatch(appointmentsFilter({ ...filter, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handlePageSizeChange = (e) => {
        setPageSize(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to first page when page size changes
    };

    const handleDeleteAppointment = async () => {
        try {

            setShowModal(false);

            // const list = [...therapistProfiles];
            // const index = therapistProfiles?.findIndex(x => x.id === currentEntry?.id);
            // delete list[index];
            // setTherapistProfiles(list.filter(Boolean));

            let result = await deleteAppointment({ id: currentEntry?.id });
            if (!result.error) {
                successMessageToast(result?.data?.message);
            }
        } catch (err) {
            console.log("error deleting appointment", err);
        }
    };

    const handleResentMail = async () => {
        try {

            setShowModal(false);

            let result = await resendAccountActivation(currentEntry?.id);
            if (!result.error) {
                successMessageToast("Account activation mail has been sent successfully.");
            }
        } catch (err) {
            console.log("error archiving discipline", err);
        }
    };

    // const handlArchive = async () => {
    //     try {

    //         setShowModal(false);

    //         const list = [...therapistProfiles];
    //         const index = therapistProfiles?.findIndex(x => x.id === currentEntry?.id);
    //         list[index] = { ...list[index], status: list[index].status == "active" ? "archived" : "active" };
    //         setTherapistProfiles(list.filter(Boolean));

    //         const result = await archiveTherapist(currentEntry?.id);
    //         refetch();
    //         if (!result?.error) successMessageToast("Record has been updated successfully.");

    //     } catch (err) {
    //         console.error("error archiving therapist", err);
    //     };
    // };

    // useLayoutEffect(() => {

    //     if (data?.records) setTherapistProfiles(data?.records)
    // }, [data]);
console.log('FILTER CHECK', filter)
    return (
        <>
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={modalType == "delete" ? handleDeleteAppointment : handleDeleteAppointment}
                type={modalType}
            />

            <AlertPop
                confirmation={showAlertModal}
                setConfirmation={setShowAlertModal}
                message={"The account has been already verified"}
            />

            <section className="ManageProfile position-relative py-4">
                <Container fluid={true}>
                    <Row>
                        <Col lg="12" className="my-2">
                            <TableHeader
                                heading={"Appointments"}
                                hideStatusFilter
                                handleFilterChange={handleFilterChange}
                                resetFilter={resetFilter}
                                filter={filter}
                                searchPlaceholder="Last, First Name, Email"
                                filterComponent={
                                    <>
                                        <li className="">
                                            <Dropdown
                                                onSelect={handleFilterChange("type")}
                                            >
                                                <Dropdown.Toggle
                                                    variant="transparent"
                                                    className="border-0 d-flex align-items-center  justify-content-center"
                                                    id="dropdown-basic"
                                                >
                                                    {<div style={{textTransform: "capitalize"}}>{filter.type || "Select Type"}</div>}
                                                    <span className="icn ms-2">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="12"
                                                            height="8"
                                                            viewBox="0 0 12 8"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                                fill="black"
                                                            />
                                                        </svg>
                                                    </span>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu
                                                    style={{
                                                        maxHeight: "200px",
                                                        overflowY: "scroll"
                                                    }}
                                                >
                                                    {
                                                        APPOINTMENT_SESSION_TYPE_OPTIONS.map((item, index) => {
                                                            return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                                        })
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </li>

                                        <li className="">
                                            <Dropdown
                                                onSelect={handleFilterChange("payment_status")}
                                            >
                                                <Dropdown.Toggle
                                                    variant="transparent"
                                                    className="border-0 d-flex align-items-center  justify-content-center"
                                                    id="dropdown-basic"
                                                >
                                                    {<div style={{textTransform: "capitalize"}}>{filter.payment_status || "Select Payment Status"}</div>}
                                                    <span className="icn ms-2">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="12"
                                                            height="8"
                                                            viewBox="0 0 12 8"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                                fill="black"
                                                            />
                                                        </svg>
                                                    </span>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu
                                                    style={{
                                                        maxHeight: "200px",
                                                        overflowY: "scroll"
                                                    }}
                                                >
                                                    {
                                                        APPOINTMENT_PAYMENT_OPTIONS.map((item, index) => {
                                                            return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                                        })
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </li>
                                    </>
                                }
                            >
                                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                    <li className="">
                                        <Link
                                            to={APPOINTMENT_ADD}
                                            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                        >
                                            <span className="icn me-1">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="19"
                                                    height="19"
                                                    viewBox="0 0 19 19"
                                                    fill="none"
                                                >
                                                    <mask
                                                        id="mask0_0_4440"
                                                        style={{ maskType: "alpha" }}
                                                        maskUnits="userSpaceOnUse"
                                                        x="0"
                                                        y="0"
                                                        width="19"
                                                        height="19"
                                                    >
                                                        <rect
                                                            width="18.7197"
                                                            height="18.7197"
                                                            fill="#D9D9D9"
                                                        />
                                                    </mask>
                                                    <g mask="url(#mask0_0_4440)">
                                                        <path
                                                            d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                            fill="white"
                                                        />
                                                    </g>
                                                </svg>
                                            </span>{" "}
                                            Add New Appointment
                                        </Link>
                                    </li>
                                </ul>
                            </TableHeader>
                            <div className="table-outer">
                                {appointmentLoading ? (
                                    <div style={{ height: "200px" }}>
                                        <LoadingIndicator />
                                    </div>
                                ) : isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(appointmentLoading || deleteAppointmentLoading) && <LoadingOverlay />}
                                        <TableLayout
                                            data={appointmentList?.records}
                                            column={column}
                                            url={'/appointment/details'}
                                            filter={filter}
                                            handleSort={handleFilterChange("sort")}
                                        />
                                    </>
                                )}
                                <CstmPagination
                                    totalPages={totalPages}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ViewAppointment;
